import React from "react";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const data = [
  {
    name: "Demonstration Centre",
    description:
      "Our demonstration center is accessible within a 7-minutes walking distance from the Training institute. It also has a farm where trainees and interns of the institute have full privileges to express, learn, master and put into direct practice all that they have learnt in the immersion class. There is also a unit where trainees and interns have the opportunity to acquire basic skills on ornamental fish culturing, fish processing and value addition, aquarium design and construction.",
  },
  {
    name: "Living Spaces",
    description:
      "Within a 5-minute walk, there is provision for accommodation facilities with capacity of 150 bed spaces designed for both male and female trainees with all functional facilities such as water, bed space, constant electricity, cable television, security, relaxation center and private chalet for families. The facilities are located in a secure estate with access to hospital facilities.",
  },
  {
    name: "AVACIF",
    description:
      "Our Aquaculture Value-Chain Incubation Facility (AVACIF) is located in the Sagamu area of Ogun State, the AVACIF also doubles as our aquaculture commercial center in order to give trainees a practical expose; the AVACIF is a one stop center for aquaculture where we have a concentration of hatchers, grow out farmers, processors and other aquaculture market actors.",
  },
  {
    name: "Well Equipped Laboratory",
    description:
      "Our laboratory is well equipped with the capacity to handle diverse laboratory tests which includes water sampling and analysis, fish disease control and quality assurance.",
  },
  {
    name: "21st Century Training Hub",
    description:
      "A serene environment with a seating capacity of about 120 trainees in our immersion classes fitted with modern multimedia equipment, high speed internet, blended learning facilities, laboratory and experienced faculty.",
  },
];

const Facilities = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "5% 0%" }}>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Facilities
      </Typography>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const { name, description } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                marginTop={{ xs: "10%", sm: "3%" }}
                key={index}
                paddingRight={{ xs: "0%", sm: "2%" }}
              >
                <Typography
                  gutterBottom
                  variant="h5"
                  color={"#3E4095"}
                  component="div"
                  fontWeight={700}
                  paddingBottom={"1%"}
                >
                  {name}
                </Typography>
                <Typography
                  paddingBottom={"5%"}
                  variant="body1"
                  color="#4f4f4f"
                >
                  {description}
                </Typography>
                <Grid item xs={12} marginTop={{ xs: "0%", sm: "4%" }}>
                  <Divider color={"#fff"} />
                </Grid>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Facilities;
